// extracted by mini-css-extract-plugin
module.exports = {"container":"SportSubMenu_container__u_Hiz","menu":"SportSubMenu_menu__I4GEK","more":"SportSubMenu_more__oKkQt","title":"SportSubMenu_title__NMNNy"};